import { runtimeEnv } from "config/runtimeEnv";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "utils/utils";

let env = runtimeEnv("API_BASE_URL")

export const bookingApi = async(data) => {
  let url = `${env}${API_ENDPOINT.Report.bookingApi}?type=${data?.type ? data?.type : ''}`
  const res = await requestInstance.get(
    url
  )
  .catch((err) => err.response)
  return setCurrentUser(res)
}

